/** Format a Date to a YYYY-MM-DD string. Returns null if no date provided. */
export const toDateStr = (d: Date | undefined | null): string | null => {
  if (!d) return null;
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};
